/**
 * Clean markdown preprocessor to support colors, highlights, alignment, and inline styling
 * without forcing raw HTML tags in the user's Markdown editor.
 */
export const processMarkdownContent = (content) => {
  if (!content || typeof content !== 'string') return '';
  let processed = content;

  // 1. Text Color: {color:#HEX}...{/color} or [text]{color:#HEX}
  processed = processed.replace(/\{color:([^}]+)\}([\s\S]*?)\{\/color\}/gi, '<span style="color:$1;">$2</span>');
  processed = processed.replace(/\[([^\]]+)\]\{color:([^}]+)\}/gi, '<span style="color:$2;">$1</span>');

  // 2. Highlight Background: {bg:#HEX}...{/bg} or {highlight:#HEX}...{/highlight} or ==text==
  processed = processed.replace(/\{bg:([^}]+)\}([\s\S]*?)\{\/bg\}/gi, '<mark style="background-color:$1; padding:2px 6px; border-radius:4px; color:#1E293B;">$2</mark>');
  processed = processed.replace(/\{highlight:([^}]+)\}([\s\S]*?)\{\/highlight\}/gi, '<mark style="background-color:$1; padding:2px 6px; border-radius:4px; color:#1E293B;">$2</mark>');
  processed = processed.replace(/==([^=\n]+)==/g, '<mark style="background-color:#FEF08A; padding:2px 6px; border-radius:4px; color:#1E293B;">$1</mark>');

  // 3. Text Alignment: [center]...[/center], [right]...[/right], [left]...[/left], [justify]...[/justify]
  processed = processed.replace(/\[center\]([\s\S]*?)\[\/center\]/gi, '<div style="text-align:center;">$1</div>');
  processed = processed.replace(/\[right\]([\s\S]*?)\[\/right\]/gi, '<div style="text-align:right;">$1</div>');
  processed = processed.replace(/\[left\]([\s\S]*?)\[\/left\]/gi, '<div style="text-align:left;">$1</div>');
  processed = processed.replace(/\[justify\]([\s\S]*?)\[\/justify\]/gi, '<div style="text-align:justify;">$1</div>');

  // 4. Underline: [u]...[/u]
  processed = processed.replace(/\[u\]([\s\S]*?)\[\/u\]/gi, '<span style="text-decoration:underline;">$1</span>');

  // 5. Superscript & Subscript: [sup]...[/sup] or ^(...) and [sub]...[/sub] or ~(...)~
  processed = processed.replace(/\[sup\]([\s\S]*?)\[\/sup\]/gi, '<sup>$1</sup>');
  processed = processed.replace(/\[sub\]([\s\S]*?)\[\/sub\]/gi, '<sub>$1</sub>');
  processed = processed.replace(/\^\(([^)]+)\)/g, '<sup>$1</sup>');
  processed = processed.replace(/~\(([^)]+)\)~/g, '<sub>$1</sub>');

  return processed;
};
